module.exports = __webpack_public_path__ + "static/img/baohu.0515ea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/baohu.png
// module id = T/DC
// module chunks = 1